module.exports = __webpack_public_path__ + "static/img-21-369bd3139c15c9e1e4d57479d1d9a1fa.jpeg";